import React from 'react'
import { ArrowLeft, Mail, Database, Settings, Eye, Download } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const Configuration = () => {
  const navigate = useNavigate()

  const configOptions = [
    {
      id: 'email',
      title: 'Configuración de Correo',
      description: 'Configura las credenciales del servidor SMTP para el envío de correos electrónicos',
      icon: Mail,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      hoverColor: 'hover:bg-blue-100',
      route: '/config/email'
    },
    {
      id: 'database',
      title: 'Configuración de Base de Datos',
      description: 'Configura la conexión a la base de datos del sistema',
      icon: Database,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      hoverColor: 'hover:bg-purple-100',
      route: '/config/database'
    },
    {
      id: 'pdf-visual',
      title: 'Configuración de Visualización PDF',
      description: 'Gestiona la visualización de elementos en el editor de PDF (bordes, etiquetas)',
      icon: Eye,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      hoverColor: 'hover:bg-green-100',
      route: '/config/pdf-visual'
    },
    {
      id: 'bulk-download',
      title: 'Descarga Masiva de Documentos',
      description: 'Descarga múltiples documentos completados filtrados por año y mes',
      icon: Download,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      hoverColor: 'hover:bg-orange-100',
      route: '/config/bulk-download'
    },
  ]

  return (
    <div className="min-h-screen" style={{background: 'var(--background-color)'}}>
      {/* Header */}
      <header className="main-header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-title">
              <h1>Configuración del Sistema</h1>
              <p>Gestiona la configuración del sistema</p>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

      {/* Descripción */}
      <div className="mb-8">
        <p className="text-gray-600 text-lg">
          Gestiona la configuración del sistema, incluyendo la configuración de correo electrónico 
          y la conexión a la base de datos.
        </p>
      </div>

      {/* Opciones de configuración */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {configOptions.map((option) => {
          const IconComponent = option.icon
          return (
            <div
              key={option.id}
              onClick={() => navigate(option.route)}
              className={`${option.bgColor} ${option.hoverColor} p-6 rounded-lg border border-gray-200 cursor-pointer transition-all duration-200 hover:shadow-md`}
            >
              <div className="flex items-start space-x-4">
                <div className={`flex-shrink-0 p-3 rounded-lg bg-white border border-gray-200`}>
                  <IconComponent className={`h-6 w-6 ${option.color}`} />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {option.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {option.description}
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* Información adicional */}
      <div className="mt-8 bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Información Importante</h3>
        <div className="space-y-2 text-sm text-gray-600">
          <p>• <strong>Configuración de Correo:</strong> Necesaria para el envío de notificaciones y contraseñas temporales.</p>
          <p>• <strong>Configuración de Base de Datos:</strong> Permite conectar con bases de datos externas para sincronización de datos.</p>
          <p>• <strong>Configuración de Visualización PDF:</strong> Controla qué elementos visuales se muestran en el editor de PDF (bordes, etiquetas) para efectos de monitoreo.</p>
          <p>• <strong>Seguridad:</strong> Todas las configuraciones se almacenan de forma segura y encriptada.</p>
        </div>
      </div>
      </div>
    </div>
  )
}

export default Configuration
